
import React, { useEffect, useState } from "react";
import HeaderSession from "../../../utils/headerSession";
import { Container, Grid } from "@mui/material";
import { useParams } from "react-router-dom";
import Loading from "../../../load/loading";
import api from "../../../services/api";
import RegisterAccess from "../../../utils/registerAccess";
import NavLateral from "./navLateral";
import { useSelector } from "react-redux";
import ProcessoLoading from "../../../load/processoLoading";


const styles = {
    grid1: {
        width: 300,
        marginBottom: 15,
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    grid2: {
        flexGrow: 1,
        marginLeft: 15,
        width: 500,
        zIndex: 1,
    }
}

export default function GestFarmacovigilancia({ element: component, ...rest }) {
    const alert = useSelector(state => state.alert.data);
    const { id } = useParams()
    const { produtoId } = useParams()
    // const navigate = useNavigate()
    const classes = styles
    const [solicitacaoAnalise, setSolicitacaoAnalise] = useState('')
    const [avaliacaoAnalitica, setAvaliacaoAnalitica] = useState('')
    const [refresh, setRefresh] = useState(produtoId)
    const [habiliteThis, setHabiliteThis] = useState(false)

    useEffect(() => {
        api.get(`/solicitacao-analise/${id}`)
            .then(response => {
                // console.log(response);
                setSolicitacaoAnalise(response.data.solicitacaoAnalise);
            }).catch(err => {
                // console.log(err)
                // if (err?.response.status === 422) { navigate(-1) }
            })
    }, [id, refresh, alert])

    // console.log(habiliteThis)

    return (
        <Container>
            <RegisterAccess page={'gestão de solicitacao de análise'} />
            <HeaderSession title={'GESTÃO DE SOLICITAÇĀO DE ANÁLISE LABORATORIAL DE AMOSTRAS DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE'} />

            {solicitacaoAnalise ?
                <Grid container>

                    <Grid item style={classes.grid1} m>
                        <NavLateral
                            observacoesFeitas={solicitacaoAnalise?.observacoes}
                            solicitacaoAnalise={solicitacaoAnalise}
                            setHabiliteThis={setHabiliteThis}
                            avaliacaoAnalitica={avaliacaoAnalitica}
                            setAvaliacaoAnalitica={setAvaliacaoAnalitica}
                        />
                    </Grid>

                    <Grid xs item style={classes.grid2} m>

                        {React.cloneElement(component, {

                            solicitacaoAnalise: solicitacaoAnalise,
                            setSolicitacaoAnalise: setSolicitacaoAnalise,
                            setRefresh: setRefresh,
                            refresh: refresh,
                            habiliteThis: habiliteThis,
                            setHabiliteThis: setHabiliteThis,
                            setAvaliacaoAnalitica: setAvaliacaoAnalitica,
                            avaliacaoAnalitica: avaliacaoAnalitica
                        })}

                    </Grid>
                </Grid>
                :
                <ProcessoLoading />
            }
        </Container>

    )
}